export default {
  date: 'August 27, 2024',
  title: 'New update: choose the window type when placing an order',
  description: 'New update: choose the window type when placing an order.',
  id: 'window-type',
  jsx: () => (
    <div class='novelty__text'>
      <p>Now, on the second step of placing an order, in the "AI set-up" section, you have the option to select the type of windows for your layout. This could be a panoramic or standard window, depending on your preferences and project specifications.</p>
      <p>You can also specify the color of the frame in the order comments: white, brown, metallic, or metallic mirror. The glass color can also be specified in the comments: standard, black, tinted, or frosted.</p>
      <p>
        If your property has specific requirements, you can easily communicate your preferences for the color of the glass and frame through your account, in the order comments, or by contacting our support team. If your layout is already completed but needs adjustments, simply email us, and we will
        update the 3D layout according to the new details.
      </p>
      <p>The process is very simple:</p>
      <p class='margin-none'>
        1. Visit our website at
        <a href='https://getfloorplan.com'> getfloorplan.com</a>.
      </p>
      <p class='margin-none'>2. Select "Place an order" on the page of any of our 3D products.</p>
      <p class='margin-none'>3. On the second step, "AI set-up," choose the window type — panoramic or standard.</p>
      <p>4. In the order comments, you can leave your preferences for the frame and glass color.</p>
      <p>Now you can customize your layout to meet your needs and get the final result without extra revisions. We are always striving to improve our service and hope that this new feature will be useful to you.</p>
      <p>Thank you for choosing us!</p>
    </div>
  ),
  thumb: 'news/27.webp',
};
